import "core-js/modules/es6.function.name";
import _createForOfIteratorHelper from '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState } from 'react';
import { useEnhancedEffect, Text, Box } from '@landr/maestro';
import { minimumNumberOfStreams, maximumNumberOfStreams } from '../../../constants/streams.es.js';
import { calculateRoyalties } from './helpers.es.js';
import { stores } from './stores.es.js';
import { RoyaltyCalculatorRoot, RoyaltyCalculatorHeader, RoyaltyCalculatorTitle, RoyaltyCalculatorSubtitle, RoyaltyCalculatorSliderContainer, RoyaltyCalculatorBody, RoyaltyCalculatorList, RoyaltyCalculatorListItem, RoyaltyCalculatorFooter } from './styled.es.js';
import { Slider } from './Slider/Slider.es.js';
import { useRoyaltyCalculatorContext } from '../../../contexts/RoyaltyCalculatorProvider/RoyaltyCalculatorContext.es.js';

var RoyaltyCalculatorContent = function RoyaltyCalculatorContent() {
  var _useRoyaltyCalculator = useRoyaltyCalculatorContext(),
      numberOfStreams = _useRoyaltyCalculator.numberOfStreams;

  var calculatorRootRef = useRef(null);

  var _useState = useState(614),
      _useState2 = _slicedToArray(_useState, 2),
      calculatorWidth = _useState2[0],
      setCalculatorWidth = _useState2[1];

  useEnhancedEffect(function () {
    if (!(calculatorRootRef === null || calculatorRootRef === void 0 ? void 0 : calculatorRootRef.current)) return;
    var observer = new ResizeObserver(function (entries) {
      var _iterator = _createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          var cr = entry.contentRect;
          setCalculatorWidth(cr.width + cr.left * 2);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(calculatorRootRef === null || calculatorRootRef === void 0 ? void 0 : calculatorRootRef.current);
    return function () {
      observer.disconnect();
    };
  }, [calculatorRootRef]);
  return (
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorRoot, {
      ref: calculatorRootRef
    },
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorHeader, null,
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorTitle, null, "Royalty Calculator"),
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorSubtitle, null, "How much can you earn from streams?*")),
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorSliderContainer, null,
    /*#__PURE__*/
    React.createElement(Text, {
      size: "sm",
      contrast: "low",
      paddingTop: "xs"
    }, "1k"),
    /*#__PURE__*/
    React.createElement(Box, {
      width: "100%",
      px: "lg",
      paddingBottom: "xs"
    },
    /*#__PURE__*/
    React.createElement(Slider, {
      min: minimumNumberOfStreams,
      max: maximumNumberOfStreams,
      width: calculatorWidth - 176
    })),
    /*#__PURE__*/
    React.createElement(Text, {
      size: "sm",
      contrast: "low",
      paddingTop: "8px"
    }, "100k")),
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorBody, null,
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorList, {
      as: "ul"
    }, stores.map(function (store) {
      return (
        /*#__PURE__*/
        React.createElement(RoyaltyCalculatorListItem, {
          key: store.name,
          as: "li"
        },
        /*#__PURE__*/
        React.createElement(Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 'sm'
          }
        }, store.icon, " ",
        /*#__PURE__*/
        React.createElement(Text, null, store.name)),
        /*#__PURE__*/
        React.createElement(Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 'xxs'
          }
        },
        /*#__PURE__*/
        React.createElement(Text, {
          contrast: "low",
          p: "none"
        }, "$"), calculateRoyalties(numberOfStreams, store)))
      );
    })),
    /*#__PURE__*/
    React.createElement(RoyaltyCalculatorFooter, null, "*Estimate based on figures from the USA, final value may vary. Many factors affect streaming royalties and this calculator should only be used as a guide.")))
  );
};

export { RoyaltyCalculatorContent };